import styled from '@emotion/styled'

import media from '../../../../styles/media'
import { fonts } from '../../../../styles/theme'
import { dark, light, darkBlue } from '../../_themes'

const S = {}

const theme = ({ themeColor }) => {
  const themes = {
    dark,
    light,
    darkBlue,
  }

  return themes[themeColor]
}

S.Footer = styled.div`
  font-family: ${fonts.menu};
  padding-top: 1.125rem;
  padding-bottom: 1.9375rem;

  a,
  [tabindex='0'] {
    &:focus {
      outline: 0.125rem solid rgba(160, 160, 160, 0.75);
      outline-offset: 0;
      box-shadow: none;
    }
  }

  ${media.md`
    padding-top: 2rem;
  `};

  ${theme};
`

S.Container = styled.div`
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  margin-left: auto;
  margin-right: auto;
  font-weight: 500;
  word-spacing: 0.4px;
  word-break: break-word;
  max-width: 65.625rem;

  ${media.md`
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  `};
`

export default S
